export type Metrics = {
    onClick: Function;
}

export const docComplete = (handleDocumentComplete: () => void) => {
    if (typeof document !== "undefined") {
        document.removeEventListener('readystatechange', handleDocumentComplete);
        if (document.readyState === 'interactive') {
            document.addEventListener('readystatechange', handleDocumentComplete, false);
        } else {
            setTimeout(handleDocumentComplete, 2);
        }
    }
  };